export const styles = ({ palette }) => ({
  link: {
    color: palette.primary.main,
    '&:hover': {
      cursor: 'pointer',
      textDecoration: 'underline',
    },
  },
});
